import { isEmpty as _isEmpty } from "lodash";

export default {
  inject: {
    eventsBus: { from: 'eventsBus' },
  },

  methods: {
    share(shareOption) {
      
      if(this.previewMode) {
        alert('Cannot share from preview');
        return;
      }

      let advocateId = '';
      if (!_isEmpty(this.advocateSubmittedInfo)) {
        advocateId = this.advocateSubmittedInfo.id;
      }

      let shareLink = this.getShareLink(shareOption, advocateId);
      if (shareOption.authEnabled) {
        this.openPopup(shareLink);
      } else {
        this.openTab(shareLink);
      }

      this.eventsBus.$emit('sharedViaSocialNetwork', { option: shareOption });
    },
    getShareLink(shareOption, advocateId) {
      if (_isEmpty(advocateId)) {
        return shareOption.link
      }
      return `${shareOption.link}&encodedAdvocateId=${advocateId}`;
      
    },
  },

  props: {
    socialShareEnabled: {
      required: true,
      type: Boolean,
    },

    shareLabel: {
      required: true,
      type: String,
    },

    shareOptions: {
      required: true,
      type: Array,
    },
    previewMode: {
      required: true,
      type: Boolean
    },
    advocateCampaignShareUrl: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    shouldShowCampaignShareLink() {
      return this.advocateCampaignShareUrl && this.hasCampaignShareUrl;
    },
    campaignShareUrl() {
      if (!this.hasCampaignShareUrl) {
        return '';
      }
      const { shareDomain = '', shareUrl = ''} = this.advocateSubmittedInfo;
      return `https://${shareDomain}/${shareUrl}`;
    },
    hasCampaignShareUrl() {
      return !_isEmpty(this.advocateSubmittedInfo.shareDomain) && !_isEmpty(this.advocateSubmittedInfo.shareUrl);
    }
  },
};
